import { createSlice } from '@reduxjs/toolkit';
import { transactionTrackerAdapter } from './transactionTrackerAdapter';
export const transactionTrackerSlicePrefix = 'superfluid_transactions';
export const createTransactionTrackerSlice = () => ({
    reducerPath: transactionTrackerSlicePrefix,
    ...createSlice({
        name: transactionTrackerSlicePrefix,
        initialState: transactionTrackerAdapter.getInitialState(),
        reducers: {
            addTransaction: transactionTrackerAdapter.addOne,
            updateTransaction: transactionTrackerAdapter.updateOne,
        },
    }),
});
//# sourceMappingURL=transactionTrackerSlice.js.map